import { render, staticRenderFns } from "./DataInside.vue?vue&type=template&id=a218f1c6&scoped=true&"
import script from "./DataInside.vue?vue&type=script&lang=js&"
export * from "./DataInside.vue?vue&type=script&lang=js&"
import style0 from "./DataInside.vue?vue&type=style&index=0&id=a218f1c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a218f1c6",
  null
  
)

export default component.exports